var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-popover',{attrs:{"placement":"bottom","width":"400","trigger":"click"}},[_c('UserMessage',{attrs:{"autoRefresh":true},on:{"update":_vm.onUpdate}}),_c('el-badge',{attrs:{"slot":"reference","is-dot":_vm.hasMessage},slot:"reference"},[_c('i',{staticClass:"icon-ring"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }